const resolveIsExpirationHard = (source: any): boolean | undefined => {
  if (typeof source.isExpirationHard === "boolean")
    return source.isExpirationHard;
  if (source.expiryType == null) return undefined;
  return String(source.expiryType).toLowerCase() === "hard";
};

export const normalizeEnrolledLo = (raw: any) => {
  const source = raw?.lo || raw || {};
  return {
    ...source,
    title: source.title || source.name || source.loTitle,
    type: source.type || source.loType,
    learning_object_type: source.learning_object_type || source.loType,
    publish_date: source.publish_date || source.publishingDate,
    isExpirationHard: resolveIsExpirationHard(source),
  };
};
